import { apiC } from "@services/api/apiC";
import type {
    StudentFinderFilterGroupCore,
    StudentFinderSearchRequestCore,
    StudentFinderSearchResponseCore,
} from "@godalming/api-types";

export const studentFinderFilterGroups: StudentFinderFilterGroupCore[] = [
    {
        label: "Student",
        key: "student",
        filters: [
            { label: "First name", key: "student.firstName", type: "text" },
            { label: "Surname", key: "student.surname", type: "text" },
            { label: "Age", key: "student.age", type: "number" },
            { label: "Student number", key: "student.studentNumber", type: "text" },
            { label: "Postcode", key: "student.postcode", type: "text" },
            { label: "Tutor group", key: "student.tutorGroup", type: "select" },
            { label: "Tutor", key: "student.tutor", type: "select" },
            { label: "Support officer", key: "student.supportOfficer", type: "select" },
            { label: "Senior tutor", key: "student.seniorTutor", type: "select" },
            { label: "School", key: "student.school", type: "select" },
            { label: "Parent email", key: "student.parentEmail", type: "text" },
            { label: "Parent surname", key: "student.parentSurname", type: "text" },
            { label: "Student type", key: "student.studentType", type: "select" },
            {
                label: "Restarter",
                key: "student.restarter",
                type: "select",
                options: [{ label: "Yes", value: "yes" }, { label: "No", value: "no" }],
            },
            { label: "Year group", key: "student.yearGroup", type: "select" },
            { label: "Student email", key: "student.studentEmail", type: "text" },
            { label: "Phone number", key: "student.phoneNumber", type: "text" },
        ],
    },
    {
        label: "Support",
        key: "support",
        filters: [
            { label: "Safeguarding tier", key: "support.safeguardingTier", type: "select" },
            { label: "Maths GCSE", key: "support.mathsGcse", type: "select" },
            { label: "English GCSE", key: "support.englishGcse", type: "select" },
            { label: "Visual processing", key: "support.visualProcessing", type: "number" },
            { label: "Handwriting speed", key: "support.handwritingSpeed", type: "select" },
            { label: "Legibility", key: "support.legibility", type: "select" },
            { label: "Vocab score", key: "support.vocabScore", type: "number" },
            { label: "Has conversation type", key: "support.conversations", type: "multiselect" },
            { label: "EHCP", key: "support.ehcp", type: "select", options: [{ label: "Yes", value: "yes" }, { label: "No", value: "no" }] },
            { label: "SEND", key: "support.send", type: "select", options: [{ label: "Yes", value: "yes" }, { label: "No", value: "no" }] },
            { label: "LAC", key: "support.lac", type: "select", options: [{ label: "Yes", value: "yes" }, { label: "No", value: "no" }] },
            { label: "Green leaf", key: "support.greenLeaf", type: "select", options: [{ label: "Yes", value: "yes" }, { label: "No", value: "no" }] },
            { label: "Green card", key: "support.greenCard", type: "select", options: [{ label: "Yes", value: "yes" }, { label: "No", value: "no" }] },
            { label: "Orange leaf", key: "support.orangeLeaf", type: "select", options: [{ label: "Yes", value: "yes" }, { label: "No", value: "no" }] },
            { label: "YC", key: "support.yc", type: "select", options: [{ label: "Yes", value: "yes" }, { label: "No", value: "no" }] },
            { label: "Pupil Premium", key: "support.pupilPremium", type: "select", options: [{ label: "Yes", value: "yes" }, { label: "No", value: "no" }] },
            { label: "Bursary", key: "support.bursary", type: "select", options: [{ label: "Yes", value: "yes" }, { label: "No", value: "no" }] },
        ],
    },
    {
        label: "Action Plans",
        key: "action-plans",
        filters: [
            { label: "AS level", key: "actionPlans.asLevel", type: "select", options: [{ label: "1", value: "1" }, { label: "2", value: "2" }] },
            { label: "PS level", key: "actionPlans.psLevel", type: "select", options: [{ label: "1", value: "1" }] },
            { label: "CC level", key: "actionPlans.ccLevel", type: "select", options: [{ label: "1", value: "1" }, { label: "2", value: "2" }, { label: "3", value: "3" }] },
            { label: "SS level", key: "actionPlans.ssLevel", type: "select", options: [{ label: "1", value: "1" }, { label: "2", value: "2" }, { label: "3", value: "3" }] },
        ],
    },
    {
        label: "Attendance",
        key: "attendance",
        filters: [
            {
                label: "Attendance percent",
                key: "attendance.attendancePercent",
                type: "number",
                defaultOperator: "lessThanOrEqual",
                operators: ["lessThan", "lessThanOrEqual", "greaterThan", "greaterThanOrEqual"],
            },
            {
                label: "Punctuality percent",
                key: "attendance.punctualityPercent",
                type: "number",
                defaultOperator: "lessThanOrEqual",
                operators: ["lessThan", "lessThanOrEqual", "greaterThan", "greaterThanOrEqual"],
            },
        ],
    },
    {
        label: "Courses",
        key: "courses",
        filters: [
            { label: "Department", key: "courses.department", type: "select" },
            { label: "Subject", key: "courses.subject", type: "select" },
            { label: "Courses", key: "courses.courses", type: "select" },
            { label: "Classes", key: "courses.classes", type: "select" },
            { label: "Teacher", key: "courses.teacher", type: "select" },
        ],
    },
];

export async function searchStudentFinder(params: StudentFinderSearchRequestCore): Promise<StudentFinderSearchResponseCore> {
    try {
        const response = await apiC.post<StudentFinderSearchResponseCore>("/StudentFinderList", params);
        return response.data;
    } catch (error) {
        console.error("Error searching student finder:", error);
        throw error;
    }
}

export async function getStudentFinderFilterGroups(): Promise<StudentFinderFilterGroupCore[]> {
    try {
        const response = await apiC.get<StudentFinderFilterGroupCore[]>("/StudentFinderFilter");
        return response.data;
    } catch (error) {
        console.error("Error fetching student finder filter groups:", error);
        throw error;
    }
}

